import React, { useState } from 'react'
import Cookies from 'js-cookie'
import axios from 'axios'
import { FaBuilding, FaSave, FaSpinner, FaPlus, FaArrowLeft } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Topbar from '../layouts/Topbar'
import Sidebar from '../layouts/Sidebar'
import API_BASE_URL from '../../../config/api'

const AddCostCenter = () => {
  const [costCenterName, setCostCenterName] = useState('')
  const [loading, setLoading] = useState(false)
  const baseUrl = API_BASE_URL

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      const token = Cookies.get('token')
      
      if (!token) {
        toast.error('Authentication token not found. Please login again.')
        return
      }

      const response = await axios.post(`${baseUrl}/api/course-centers/`, {
        name: costCenterName
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      toast.success('Cost Center added successfully!')
      setCostCenterName('')

    } catch (err) {
      console.error('Error adding cost center:', err)
      const errorMessage = err.response?.data?.message || 'Failed to add cost center. Please try again.'
      toast.error(errorMessage)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Topbar />
      <Sidebar />
      <div className="add-cost-center-container">
        <div className="page-header">
          <div className="header-content">
            <div className="header-left">
              <Link to="/hr/cost-centers" className="back-button">
                <FaArrowLeft />
                <span>Back to Cost Centers</span>
              </Link>
              <div className="page-title">
                <h1>Add New Cost Center</h1>
              </div>
            </div>
          </div>
        </div>

        <div className="wrapper">
          <div className="form-container">
            <div className="form-header">
              <div className="form-icon">
                <FaPlus />
              </div>
              <div className="form-title">
                <h2>Cost Center Details</h2>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="cost-center-form">
              <div className="form-group">
                <label htmlFor="costCenterName">
                  <span className="label-text">Cost Center Name</span>
                  <span className="required">*</span>
                </label>
                <div className="input-wrapper">
                  <div className="input-icon">
                    <FaBuilding />
                  </div>
                  <input
                    style={{maxWidth: '600px'}}
                    type="text"
                    id="costCenterName"
                    value={costCenterName}
                    onChange={(e) => setCostCenterName(e.target.value)}
                    placeholder="Enter cost center name."
                    required
                    disabled={loading}
                    className=""
                  />
                </div>
              </div>

              <div className="form-actions">
                <Link to="/hr/cost-centers" className="cancel-button">
                  Cancel
                </Link>
                <button
                  type="submit"
                  className="submit-button"
                  disabled={loading || !costCenterName.trim()}
                >
                  {loading ? (
                    <>
                      <FaSpinner className="spinner" />
                      <span>Creating Cost Center...</span>
                    </>
                  ) : (
                    <>
                      <FaSave />
                      <span>Create Cost Center</span>
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddCostCenter
